import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {

  constructor() { }

  copyText(text: string): void {
    navigator.clipboard.writeText(text).catch(err => {
      console.error('Falha ao copiar texto: ', err);
    });
  }
}
